import Icon from '@/components/snippets/icon/icon'
import { isPriceFilterField, formatPriceValue, RANGE_INDICATOR } from './FilterUtils'
import { isSizeFilter, formatUniversalSizeValue } from './SizeFilterUtils'
import { useMarketPrices } from '@/components/helpers/market-price'

export function FilterSelected({ activeFilters, onRemove, onClear }) {
  useMarketPrices()

  if (!activeFilters || activeFilters.size === 0) return null

  const formatFilterValue = (filter) => {
    const [field, value] = filter.split(':')

    if (isPriceFilterField(field)) {
      const [min, max] = value.split(RANGE_INDICATOR)
      return `${formatPriceValue(parseFloat(min))} ↔ ${formatPriceValue(parseFloat(max))}`
    }

    if (isSizeFilter(field, value)) {
      return formatUniversalSizeValue(value).replaceAll(RANGE_INDICATOR, '↔')
    }

    return value.replaceAll(RANGE_INDICATOR, '↔')
  }

  return (
    <div className="flex flex-wrap gap-x-1 px-margin py-0.5 border-b border-borders-default">
      {[...activeFilters].map((filter) => {
        return (
          <button className="shrink-0 btn btn-text btn-primary btn-s w-fit whitespace-nowrap" onClick={() => onRemove(filter)} aria-label={`Remove ${formatFilterValue(filter)} filter`}>
            {formatFilterValue(filter)}
            <div className="flex size-[8px] children:size-full">
              <Icon id="close" />
            </div>
          </button>
        )
      })}
      <button className="shrink-0 btn btn-tertiary btn-text btn-s w-fit whitespace-nowrap" onClick={onClear} aria-label="Clear all filters">
        <span className="text-line text-line-large">
          Clear all
        </span>
      </button>
    </div>
  )
}
